
<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px"
  transition="dialog-transition" >
    <v-card>
      <v-card-title>
        <span class="headline">Editando créditos do cliente</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-col cols='12' class="pa-0">
            <v-col cols='12' class="pa-0">
              <v-text-field 
                v-model="new_client.client_credit_attributes.original_limit_aux" 
                type="number" 
                :rules="required"
                label="Limite de Crédito (R$)" 
                @input="recalcLimit()"
              ></v-text-field>
            </v-col>
            <v-col cols='12' class="pa-0">
              <v-text-field 
                :value="new_client?.client_credit_attributes?.limit_aux?.replace(/\d(?=(\d{3})+\.)/g, '$&,')"
                label="Crédito atualizado (R$)" 
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols='12' class="pa-0">
              <v-text-field 
                v-model="new_client.client_credit_attributes.blockingTime" 
                :rules="required"
                label="Tempo para Bloqueio"
              ></v-text-field>
            </v-col>
            <v-col cols='12' class="pa-0">
              <v-text-field v-model="new_client.client_credit_attributes.comment" label="Comentários"></v-text-field>
            </v-col>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn cancel @click="closeDialog"></f-btn>
        <f-btn save @click="emitUpdate"></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { VMoney } from 'v-money'
import validations from '@/mixins/validations.js'

export default {
  name: 'ClientEditClientCreditDialog',
  directives: { money: VMoney },
  mixins:[ validations ],
  props: {
    change_dialog:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: true,
      new_client:{ 
        client_credit_attributes: {
          blockingTime:null,
          comment:null,
          limit:"",
          original_limit:"",
        }
      },
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
      can_recalc: false,
      new_limit: 0,
      menu_due: false,
    }
  },
  methods: {
    setClientCredit(){
      if (this.oneClient?.data.attributes.id){
        if (this.oneClient?.data.attributes.credits.data.attributes != null) {
          var { blockingTime, comment, limit, original_limit, id } = this.oneClient?.data.attributes.credits.data.attributes
          this.new_client = {
            id: this.oneClient?.data.attributes.id,
            client_credit_attributes: {
              blockingTime: blockingTime,
              limit: limit,
              limit_aux: limit,
              original_limit_aux: original_limit,
              original_limit: original_limit,
              id: id,
              comment: comment
            },
          }
        }
      } else {
        this.new_client = { 
          client_credit_attributes: {
            blockingTime:null,
            comment:null,
            limit:"",
            original_limit:"",
          }
        }
      }
      this.can_recalc = true
    },
    recalcLimit() {
      var { original_limit, original_limit_aux, limit, limit_aux } = this.new_client.client_credit_attributes
      if(this.can_recalc && typeof(parseFloat(limit)) == 'number'  && typeof(parseFloat(limit_aux)) == 'number'  && typeof(parseFloat(original_limit)) == 'number'  && typeof(parseFloat(original_limit_aux)) == 'number'){
        this.new_limit = parseFloat(original_limit_aux) - parseFloat(original_limit) + parseFloat(limit)
        if(!isNaN(this.new_limit)) {
          this.new_client.client_credit_attributes.original_limit = original_limit_aux
          this.new_client.client_credit_attributes.limit = this.new_limit
          this.new_client.client_credit_attributes.limit_aux = this.new_client?.client_credit_attributes?.limit?.toFixed(2)
        }
      }
    },
    emitUpdate(){
      if(this.$refs.form.validate()){
        if(!isNaN(this.new_limit)) {
          this.new_client.client_credit_attributes.limit = parseFloat(this.new_client.client_credit_attributes.limit_aux)
          this.new_client.client_credit_attributes.original_limit = parseFloat(this.new_client.client_credit_attributes.original_limit_aux)
  
          this.$emit('update', {new_client: this.new_client, model: 'credit'})
        }
      }
    },
    closeDialog(){
      this.$emit('close')
    }
  },
  computed:{
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  mounted () {
    this.setClientCredit();
  },
}
</script>
